export const ENTITY_PATH = '/account_drafts';

export enum ACCOUNT_DRAFT_STATUS {
    NEW = 'NEW',
    NEED_CHECK = 'NEED_CHECK',
    COMPLETED = 'COMPLETED',
    DECLINED = 'DECLINED',
}

export const ACCOUNT_DRAFT_LIST_STATUSES: ACCOUNT_DRAFT_STATUS[] = [
    ACCOUNT_DRAFT_STATUS.NEW,
    ACCOUNT_DRAFT_STATUS.NEED_CHECK,
    ACCOUNT_DRAFT_STATUS.DECLINED,
];

export const ACCOUNT_DRAFT_ATTACHMENTS_MAX_COUNT = 10;
export const ACCOUNT_DRAFT_DECLINED_REASON_MAX_LENGTH = 1000;

export enum ACCOUNT_DRAFT_RESPONSE_ERROR {
    INVALID_ACCOUNT_TYPE = 'INVALID_ACCOUNT_TYPE',
    AGENT_PAYMENT_METHOD_INFO_NOT_FOUND = 'AGENT_PAYMENT_METHOD_INFO_NOT_FOUND',
}
